/**
 * 항목2 — 상품/이벤트 추가입력·동의 4몰별 관리.
 *
 * be-catalog 계약(V101): ProductCollectionField·ProductConsentTerm·EventCollectionField 에
 * `mall VARCHAR(16)` 추가. admin GET/PUT 은 `?mall=<BCP-47>` per-mall 분리(몰별 독립 폼).
 * mall 키 = BCP-47(catalog LocaleConfig.SUPPORTED_LOCALES 정합) — order_form_fields 미러.
 *
 * 기존행(마이그 default 'ko-KR')은 국내(ko-KR) 탭에만 노출 → 운영자가 타몰을 재구성한다.
 */
export const COLLECTION_MALLS = ['ko-KR', 'ja-JP', 'zh-CN', 'en-US'] as const;
export type CollectionMall = (typeof COLLECTION_MALLS)[number];

/** 기본(정본) 몰 — 신규 진입 탭, 기존 단일세트가 귀속되는 몰. */
export const DEFAULT_COLLECTION_MALL: CollectionMall = 'ko-KR';

/** 몰 탭 라벨(BO 한국어 전용 — 콘텐츠 번역 아님, 몰 구분 표기). */
export const COLLECTION_MALL_LABELS: Record<CollectionMall, string> = {
  'ko-KR': '국내몰',
  'ja-JP': '일문몰',
  'zh-CN': '중문몰',
  'en-US': '영문몰',
};

/** QA-565 — 몰별 추가입력·동의 저장 실패 안내. */
export const collectionSaveFailedMessage = (malls: readonly CollectionMall[]): string =>
  `추가입력·동의 항목을 저장하지 못했습니다(${malls.map((m) => COLLECTION_MALL_LABELS[m]).join(', ')}). 잠시 후 다시 저장해 주세요.`;
